"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSearchThin = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M46 44l1.08-1.39a20.86 20.86 0 0 0 4.4-12.87A21.13 21.13 0 1 0 41.9 47.4l1.36-.89L57.51 60.8a1.94 1.94 0 0 0 2.63 0 1.86 1.86 0 0 0 0-2.63zm-15.6 3.15a17.37 17.37 0 1 1 17.37-17.37A17.39 17.39 0 0 1 30.4 47.15z"
  })),
  height: undefined,
  width: undefined
});
IconSearchThin.displayName = 'IconSearchThin';
var _default = IconSearchThin;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/search-thin.js
// module id = 225
// module chunks = 0